import { z } from 'zod'
import { CreateAlertSettingsSchema } from './CreateAlertSettings.schema'
import { CreateAndUpdateAlertSettingsDto } from '../../../domain/dtos/CreateAndUpdateAlertSettings.dto'

export const UpdateAlertSettingsSchema = CreateAlertSettingsSchema.safeExtend({
	id: z.uuid({ message: 'id inválido' }).nonempty(),
}).transform((data) => {
	return {
		id: data.id,
		areas_monitoradas_vinculadas: data.monitoredAreas.map((id: string) => {
			return { id_area_monitorada_vinculada: id }
		}),
		descricao: data.description,
		distancia_buffer: data.buffer * 1000,
		porcentagem_confianca_minima: data.minDetectionConfidence,
	} as unknown as CreateAndUpdateAlertSettingsDto
})
